module.exports = __webpack_public_path__ + "static/media/13_Event Location.0de3f177.jpg";